import { render, staticRenderFns } from "./SignupConfirm.vue?vue&type=template&id=2cd41580"
import script from "./SignupConfirm.vue?vue&type=script&lang=js"
export * from "./SignupConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports